<template>
  <b-container class="main-area">
    <b-row align-h="center">
      <b-col md="5">
        <b-card no-body>
          <b-tabs card class="nav-fill">
            <b-tab title="Вход">
              <LoginForm/>
            </b-tab>
            <b-tab title="Регистрация">
              <CreateAccountForm/>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import LoginForm from '../forms/LoginForm'
import CreateAccountForm from '../forms/CreateAccountForm'
// import { mapActions } from 'vuex'

export default {
  components: {
    LoginForm,
    CreateAccountForm
  }
}
</script>

<style scoped>
  .main-area {
    padding-top: 30vh;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?1990c670